import React, { useMemo } from 'react';
import { Box, FlatTextInput, Text } from '@common-fe/common-fe';

import { CLOSE_SYMBOL, OPEN_SYMBOL } from './FormulaDragAndDrop/FormulaDragAndDrop';
import FormulaSubfield from './FormulaSubfield';

interface Props {
  value: string;
  text?: string;
  placeholder?: string;
  isNoFormula?: boolean;
}

export const MAX_FORMULA_COUNT = 7;
export const MAX_NO_FORMULA_COUNT = 8;

const FundIDFOrmulaResult: React.FC<Props> = ({ value, text, placeholder, isNoFormula }) => {
  const length = useMemo(() => value
    .replace(OPEN_SYMBOL, '')
    .replace(CLOSE_SYMBOL, '').length, [value]);
  const currentMaxCount = useMemo(() => (isNoFormula ? MAX_NO_FORMULA_COUNT : MAX_FORMULA_COUNT), [isNoFormula]);
  const isError = useMemo(() => length > currentMaxCount, [currentMaxCount, length]);
  const color = useMemo(() => {
    if (!length) {
      return 'textDisabled';
    }
    if (isError) {
      return 'error';
    }
    return 'success';
  }, [isError, length]);
  return (
    <FormulaSubfield
      label="Final fund ID formula"
      text={text || `The Final Fund ID formula consists of the Prefix plus Expression. The total number of symbols in the Final Fund ID formula must not exceed ${currentMaxCount} symbols.`}
    >
      <Box direction="row" align="center">
        <Box width="180px">
          <FlatTextInput
            disabled
            placeholder={placeholder || 'Prefix{}'}
            value={value}
          />
        </Box>
        <Text margin={{ left: 's' }} weight={400} data-testid={`counter-color-${color}`} color={color}>
          {`${length}/${currentMaxCount} symbols`}
        </Text>
      </Box>
      {isError && (
        <Text data-testid="fund-formula_error-mesage" color="danger" margin={{ top: 's' }} weight={400}>
          Please change the Prefix or Formula expression to not exceed {currentMaxCount} symbols.
        </Text>
      )}
    </FormulaSubfield>
  );
};

export default FundIDFOrmulaResult;
